import { createChatMarkdownRenderer, renderAgentServiceMarkdown } from "./agent-service-markdown.js";

const markdown = createChatMarkdownRenderer();
const externalLink = markdown.renderer.rules.link_open;
// 与原Markdown显示层保持同样的64条/1MiB上限，输入或Socket更新不重复解析历史回答。
const cache = new Map();
let cacheBytes = 0;
// 内部引用在当前群定位；普通外链仍保持原来的安全新窗口行为。
markdown.renderer.rules.link_open = (tokens, index, options, env, renderer) =>
  tokens[index].attrGet("data-workflow-sequence")
    ? renderer.renderToken(tokens, index, options)
    : externalLink(tokens, index, options, env, renderer);

/** 只改写Agent正文的文本Token；已有链接、代码和不可信HTML不会被二次解释。 */
markdown.core.ruler.after("inline", "workflow-message-citations", state => {
  for (const block of state.tokens) {
    if (!block.children) continue;
    const children = [];
    let linkDepth = 0;
    for (const token of block.children) {
      if (token.type === "link_open") linkDepth++;
      if (token.type === "link_close") linkDepth--;
      if (token.type !== "text" || linkDepth) { children.push(token); continue; }
      let cursor = 0;
      const text = value => { if (value) { const part = new state.Token("text", "", 0); part.content = value; children.push(part); } };
      for (const match of token.content.matchAll(/(?:消息|訊息|Message)\s*[#＃]\s*([1-9]\d{0,18})(?!\d)/giu)) {
        if (!Number.isSafeInteger(Number(match[1])) || Number(match[1]) >= Number.MAX_SAFE_INTEGER) continue;
        text(token.content.slice(cursor, match.index));
        const open = new state.Token("link_open", "a", 1);
        open.attrs = [["href", `#${state.env.prefix}-${match[1]}`], ["class", "workflow-message-citation"], ["data-workflow-sequence", match[1]]];
        children.push(open); text(match[0]); children.push(new state.Token("link_close", "a", -1));
        cursor = match.index + match[0].length;
      }
      text(token.content.slice(cursor));
    }
    block.children = children;
  }
});

/** 历史Agent回复也能定位原文；消息及服务端引用保持原值，不伪造跨群地址。 */
export function renderWorkflowChatMessage(message, prefix = "workflow-message") {
  if (message?.messageType !== "AGENT") return renderAgentServiceMarkdown(message?.content);
  const safePrefix = /^[A-Za-z0-9_-]+$/u.test(prefix) ? prefix : "workflow-message";
  const text = String(message.content || ""), key = `${safePrefix}\u0000${text}`;
  const existing = cache.get(key);
  if (existing) { cache.delete(key); cache.set(key, existing); return existing.html; }
  const html = markdown.render(text, { prefix: safePrefix });
  const bytes = (key.length + html.length) * 2;
  if (bytes <= 1024 * 1024) {
    cache.set(key, { html, bytes }); cacheBytes += bytes;
    while (cache.size > 64 || cacheBytes > 1024 * 1024) {
      const oldest = cache.keys().next().value; cacheBytes -= cache.get(oldest).bytes; cache.delete(oldest);
    }
  }
  return html;
}
